import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { infoIcon, linkIcon } from 'src/app/app-icons';

@Component({
  selector: 'app-invalid-invitation',
  standalone: false,
  templateUrl: './invalid-invitation.component.html',
  styleUrl: './invalid-invitation.component.scss',
})
export class InvalidInvitationComponent {
  readonly steps = [ 
    'MY-INVITATION.INVALID-INVITATION.STEPS.OPEN-EMAIL', 
    'MY-INVITATION.INVALID-INVITATION.STEPS.USE-DIRECT-LINK', 
    'MY-INVITATION.INVALID-INVITATION.STEPS.USE-LATEST-EMAIL' 
  ];

  constructor(
    private sanitized: DomSanitizer,
  ) {
  }
  
  getLinkIcon(): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(linkIcon);
  }

  getInfoIcon(): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(infoIcon);
  }
}
